module.exports = __webpack_public_path__ + "static/media/logo-ringo.39268434.png";